import React, { FC } from 'react'

import { HeaderLogo } from '@/components/Header/styles'
import { PageName } from '@/components/PageHeader/styles'
import { icons } from '@/constants/icons'
import { HeaderElem } from '@/containers/Search/styles'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

export const SearchHeader: FC<{
  className?: string
}> = ({ className }) => {
  const { t } = useCommonTranslation()

  return (
    <HeaderElem className={className}>
      <PageName>{t('SEARCH')}</PageName>
      <HeaderLogo
        src={icons.logoApp.logoWhite}
        alt="logo"
        className="header-logo"
      />
    </HeaderElem>
  )
}
